import { NorthEast } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import { convertToLabel } from '../../../utils/helper'

type Props = {
  data: any
  labelTitle: string
  valueTitle: string
  secondaryValueTitle?: string
  thirdValueTitle?: string
  className?: string
  bodyClassName?: string
  handleFilterChange?: any
  filters?: any
  viewAction?: any
  blockAction?: boolean
  capitalizeTitle?: boolean
  secondaryValueWidth?: string // Add new prop
  isTitleVisible?: boolean
}

const ListView = (props: Props) => {
  const {
    data,
    className,
    bodyClassName,
    labelTitle,
    valueTitle,
    handleFilterChange,
    viewAction,
    filters,
    secondaryValueTitle,
    thirdValueTitle,
    blockAction,
    capitalizeTitle,
    secondaryValueWidth, // Destructure new prop
    isTitleVisible = true,
  } = props

  // State to keep track of selected rows (using indexes for identification)
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  // Handle row click (toggle selection)
  const handleRowClick = (index: number) => {
    if (blockAction) {
      return true
    }
    if (selectedRows.includes(index)) {
      // Unselect the row if it's already selected
      if (handleFilterChange) {
        setSelectedRows(selectedRows.filter((i) => i !== index))
        handleFilterChange(selectedRows.filter((i) => i !== index))
      }
    } else {
      // Select the row if it's not selected
      if (handleFilterChange) {
        setSelectedRows([...selectedRows, index])
        handleFilterChange([...selectedRows, index])
      }
    }
  }

  const secondaryWidthClass = secondaryValueWidth || 'w-32' // Use prop or default

  return (
    <div className={`flex flex-col border rounded-lg relative bg-white ${className}`}>
      {isTitleVisible && (
        <Box
          sx={{
            color: 'secondary.main',
            backgroundColor: 'primary.main',
          }}
          className="flex rounded-t-lg"
        >
          <div className="flex-1 p-4 text-sm ">{labelTitle}</div>
          <div className="text-sm flex">
            {thirdValueTitle ? <div className="py-4 w-32 text-center">{thirdValueTitle}</div> : ''}
            {secondaryValueTitle ? <div className={`py-4 ${secondaryWidthClass} text-center`}>{secondaryValueTitle}</div> : ''}

            <div className="p-4 min-w-32 text-right">{valueTitle}</div>
          </div>
        </Box>
      )}
      {data?.length < 1 ? <Typography className="text-center text-gray-500 pt-5 absolute top-12 left-1/2 -translate-x-1/2 ">No Data To Display</Typography> : null}
      <div className={`${bodyClassName} p-2`}>
        {data?.map((item: any, index: number) => (
          <Box
            key={index}
            sx={{
              backgroundColor:
                filters !== undefined && filters !== null ? (filters.includes(item.id) ? 'secondary.main' : '') : selectedRows.includes(item.id) ? 'secondary.main' : '',
            }}
            // style={{ background: selectedRows.includes(index) ? 'red' : '' }}
            className={`flex border-b cursor-pointer transition duration-300 rounded-lg mb-2`}
            onClick={() => handleRowClick(item.id)} // Toggle selection
          >
            <div className="flex-1 px-2 py-4 flex items-center text-sm break-all">
              {item?.color ? (
                <span style={{ background: item?.color }} className={`flex h-4 w-4 rounded mr-2`}>
                  {/* {item?.color} */}
                </span>
              ) : (
                ''
              )}

              {capitalizeTitle
                ? convertToLabel(item.label?.length > 40 ? `${item.label?.slice(0, 40)}...` : item.label)
                : item.label?.length > 40
                  ? `${item.label?.slice(0, 40)}...`
                  : item.label}
            </div>
            {thirdValueTitle ? <div className="w-32 p-4 text-center text-sm">{item.thirdValue}</div> : ''}
            {secondaryValueTitle ? <div className={`${secondaryWidthClass} p-4 text-center text-sm`}>{item.secondaryValue}</div> : ''}
            <div className="w-32 p-4 text-right text-sm">
              {item.value}
              {viewAction ? <NorthEast onClick={(e) => { e.stopPropagation(); e.preventDefault(); viewAction(item.label, item.id, item?.subsidiaryMasterId); }} className="ml-2" fontSize="small" /> : ''}
            </div>
          </Box>
        ))}
      </div>
    </div>
  )
}

export default ListView
